import { Stack } from 'expo-router';

function IncentiveLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default IncentiveLayout;
